import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  useAddRowLevelAccessMutation,
  useGetSingleDSMutation,
} from "./EditDataSourceSlice";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useGetAllGroupsQuery } from "../Group/groupApislice";
import { useMyContext } from "../../MyContext";

export default function RowLevelAccess() {
  const [searchParams] = useSearchParams();
  const dataSourceId = searchParams.get("dataSourceId");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const { setToast } = useMyContext();
  const userDetails = {
    name: "Parag",
    roles: {
      Creator: "Creator",
      Admin: "Admin",
      Connector: "Connector",
    },
    _id: "67655449333c61290d1d4d60",
    username: "parag",
    email: "paragagarwal675@gmail.com",
    password: "$2b$10$z18hjPF3wP5EC9VpwDJCs.z5rTwURMjdK3c9agdcHTrTLEJMdZ.6W",
    Group: [],
    defaultHomePage: true,
    Active: true,
    joining_date: null,
    Gender: "Male",
    Dob: "2001-01-01T18:30:00.000Z",
    Phone: 9350251847,
    Region: "North",
    Zone: "India",
    userCompanylogo:
      "https://res.cloudinary.com/dccfiolig/image/upload/v1738821091/IMG-20250116-WA0010_whjnm4.jpg",
  };

  const {
    data: groups = [],
    isLoading,
    isError,
    isSuccess,
    error,
    refetch,
  } = useGetAllGroupsQuery();

  const [
    getSingleDS,
    {
      data: dataSourceDetails,
      isLoading: isDataSourceDetailsLoading,
      isError: isDataSourceDetailsError,
    },
  ] = useGetSingleDSMutation();

  useEffect(() => {
    if (dataSourceId) getSingleDS({ dataSourceId, allDetails: true });
  }, [dataSourceId, getSingleDS]);

  const [
    addRowLevelAccess,
    {
      data: rowLevelAccessData,
      isLoading: isRowLevelAccessLoading,
      isError: isRowLevelAccessError,
      isSuccess: isRowLevelAccessSuccess,
      error: rowLevelAccessError,
    },
  ] = useAddRowLevelAccessMutation();

  const {
    id,
    Owner,
    NickName,
    DataBaseName,
    TableName,
    DataBaseType,
    AddedBy,
  } = dataSourceDetails?.ConnectionDetails || {};
  const columns = dataSourceDetails?.ColumnDetails || [];
  // console.log(dataSourceDetails?.ConnectionDetails);

  // ✅ Store mapping of columnName -> { matchedWith, logicalOperator }
  const [mappings, setMappings] = useState({});

  const handleSelectChange = (columnName, field, value) => {
    setMappings((prev) => ({
      ...prev,
      [columnName]: {
        ...prev[columnName],
        [field]: value,
      },
    }));
  };

  const handleApply = () => {
    const matched = Object.entries(mappings).map(
      ([columnName, { matchedWith, logicalOperator }]) => ({
        columnName,
        matchedWith: matchedWith || "—",
        logicalOperator: logicalOperator || "AND",
      })
    );
    if (!selectedGroup) {
      setToast({
        message: "please select a group first",
        status: "error",
      });
      return;
    }
    const body = {
      dataSourceId,
      matchedArray: matched,
      relationType: "match",
      groupId: selectedGroup,
    };

    console.log(body);
    addRowLevelAccess(body);
  };

  function GroupTable({ groups }) {
    if (!groups?.length) return null;

    return (
      <div className="w-1/2 border border-gray-200 rounded-md overflow-y-auto shadow-sm">
        <table className="w-full text-sm text-left border-collapse">
          <thead className="sticky top-0 bg-white z-10">
            <tr>
              <th className="border-b text-left px-2 py-2 font-medium text-gray-700">
                Group Name
              </th>
            </tr>
          </thead>
          <tbody>
            {groups.map((group, idx) => (
              <tr
                key={group._id || idx}
                className={`cursor-pointer ${
                  selectedGroup === group._id
                    ? "bg-blue-100"
                    : idx % 2 === 0
                    ? "bg-gray-50"
                    : "bg-white"
                } hover:bg-blue-50`}
                onClick={() => setSelectedGroup(group._id)}
              >
                <td className="border-b text-left px-2 py-1">
                  {group.groupName}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  function ColumnMappingTable({
    columns,
    mappings,
    handleSelectChange,
    userDetails,
  }) {
    if (!columns?.length) return null;

    const userFields = Object.keys(userDetails).filter(
      (key) => typeof userDetails[key] !== "object"
    );

    return (
      <div className="w-1/2 border border-gray-200 rounded-md overflow-y-auto shadow-sm h-full">
        <table className="w-full text-sm text-left border-collapse">
          <thead className="bg-gray-100 text-gray-700 uppercase text-[12px] sticky top-0">
            <tr>
              <th className="px-3 py-2 border-b">Column Name</th>
              <th className="px-3 py-2 border-b">Data Type</th>
              <th className="px-3 py-2 border-b">Match With (User Field)</th>
              <th className="px-3 py-2 border-b">Logical Operator</th>
            </tr>
          </thead>
          <tbody>
            {columns.map((col, idx) => {
              const current = mappings[col.columnName] || {};
              const isMapped = !!current.matchedWith;

              return (
                <tr
                  key={col.uuid || idx}
                  className={`border-b transition-colors ${
                    isMapped
                      ? "bg-blue-50 hover:bg-blue-100"
                      : "hover:bg-gray-50"
                  }`}
                >
                  <td className="px-3 py-2 font-medium text-gray-800">
                    {col.columnName}
                  </td>
                  <td className="px-3 py-2 text-gray-600">
                    {col.dataType || "—"}
                  </td>

                  {/* Match With */}
                  <td className="px-3 py-2 text-gray-600">
                    <select
                      className="w-full border border-gray-300 rounded-md text-sm px-2 py-1 outline-none focus:ring-1 focus:ring-blue-600"
                      value={current.matchedWith || ""}
                      onChange={(e) =>
                        handleSelectChange(
                          col.columnName,
                          "matchedWith",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Select user field...</option>
                      {userFields.map((key) => (
                        <option key={key} value={key}>
                          {key}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* Logical Operator */}
                  <td className="px-3 py-2 text-gray-600">
                    <select
                      className="w-full border border-gray-300 rounded-md text-sm px-2 py-1 outline-none focus:ring-1 focus:ring-blue-600"
                      value={current.logicalOperator || ""}
                      onChange={(e) =>
                        handleSelectChange(
                          col.columnName,
                          "logicalOperator",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Select operator...</option>
                      {["AND", "OR"].map((key) => (
                        <option key={key} value={key}>
                          {key}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <main className="overflow-hidden flex flex-col w-full h-[94vh] bg-gray-50">
      <section className="flex flex-col items-start justify-start gap-2 border border-b-0 border-gray-300 h-full w-full bg-white rounded-t-lg shadow-sm">
        {/* Header */}
        <header className="w-full flex items-center justify-between border-b border-gray-200 px-4 py-2 bg-gray-100">
          <h2 className="font-semibold flex items-center justify-start text-gray-800">
            Row Level Access on {NickName || id}
            {dataSourceDetails && (
              <AiOutlineInfoCircle
                className="ml-1 text-gray-600 cursor-pointer"
                title={`Owner: ${Owner || "N/A"}
Database: ${DataBaseName || "N/A"}
Table: ${TableName || "N/A"}
Type: ${DataBaseType || "N/A"}
Added By: ${AddedBy || "N/A"}`}
              />
            )}
            {isRowLevelAccessError && rowLevelAccessError ? (
              <p className="text-red-600 ml-1">
                {rowLevelAccessError?.data?.message ||
                  "unable to update the access"}
              </p>
            ) : null}
            {isRowLevelAccessSuccess && rowLevelAccessData ? (
              <p className="text-green-600 ml-1">
                {rowLevelAccessData?.message ||
                  "Row Level Access replaced successfully."}
              </p>
            ) : null}
          </h2>

          <div className="flex items-center justify-end gap-2">
            <button className="border border-gray-400 rounded-md px-5 text-[12px] py-1 truncate hover:bg-gray-100">
              Cancel
            </button>
            <button
              onClick={handleApply}
              className="border border-gray-400 rounded-md px-5 text-[12px] py-1 bg-blue-950 text-white hover:bg-blue-900 truncate"
            >
              {isRowLevelAccessLoading ? "Applying..." : "Apply"}
            </button>
          </div>
        </header>
        {/* Column section */}
        <div className="flex flex-col gap-3 items-start justify-start px-4 py-1 w-full overflow-hidden h-full">
          <div className="flex items-start justify-center w-full gap-4 h-full">
            <GroupTable groups={groups} />
            <ColumnMappingTable
              columns={columns}
              mappings={mappings}
              handleSelectChange={handleSelectChange}
              userDetails={userDetails}
            />
          </div>
        </div>
      </section>
    </main>
  );
}
